<template>
  <div class="agent-receiving" v-wechat-title="title">
    <div class="container" v-if="showPage">
      <div class="appointment-list-2">
        <van-cell-group :border="false">
          <template #title>
            <span class="custom-title">基础信息</span>
          </template>

          <van-cell :border="false">
            <div style="color:#9D9D9D;white-space:nowrap;">患者姓名：</div>
            <div>{{ patient_name }}</div>
          </van-cell>
          <van-cell :border="false">
            <div class="alignment-flex">
              <div style="color:#9D9D9D;white-space:nowrap;">当前轮次、周期：</div>
              <div>第{{ rounds }}轮次 第{{ rounds_phase }}周期</div>
            </div>
          </van-cell>
          <div v-for="(item, index) in drugInfo" :key="index">
            <van-cell :border="false">
              <div class="alignment-flex">
                <div style="color:#9D9D9D;white-space:nowrap;">药品名称：</div>
                <div>{{ item.drug_name }}</div>
              </div>
            </van-cell>
            <van-cell :border="false">
              <div class="alignment-flex">
                <div style="color:#9D9D9D;white-space:nowrap;">药品规格：</div>
                <div>{{ item.specifications }}</div>
              </div>
            </van-cell>
            <van-cell :border="false">
              <div class="alignment-flex">
                <div style="color:#9D9D9D;white-space:nowrap;">药品数量：</div>
                <div>{{ item.pre_quantity }}</div>
              </div>
            </van-cell>
          </div>
          <van-cell :border="false">
            <div class="alignment-flex">
              <div style="color:#9D9D9D;white-space:nowrap;">项目药房：</div>
              <div>{{ drugstore }}</div>
            </div>
          </van-cell>
          <van-cell :border="false">
            <div class="alignment-flex">
              <div style="color:#9D9D9D;white-space:nowrap;">药房地址：</div>
              <div>{{ drugstore_address }}</div>
            </div>
          </van-cell>
          <van-cell :border="false">
            <div class="alignment-flex">
              <div style="color:#9D9D9D;white-space:nowrap;">药房联系方式：</div>
              <div>{{ drugstore_phone }}</div>
            </div>
          </van-cell>
          <van-cell :border="false">
            <div class="alignment-flex">
              <div style="color:#9D9D9D;white-space:nowrap;">公益专员联系方式：</div>
              <div v-if="volunteer_name" style="word-break:normal;">{{ volunteer_name }}/ {{ volunteer_phone }}</div>
              <div v-else style="word-break:normal;">暂无</div>
            </div>
          </van-cell>
        </van-cell-group>
      </div>

      <div class="btn-group flex-col">
        <van-button type="default" class="" round @click="selfReceived" color="#0AA8AF">本人领药</van-button>
        <van-button type="default" class="" round @click="showPage2(1)" color="#0AA8AF" v-if="showAgentApply">代领药人领药</van-button>
      </div>
    </div>
    <div class="container" v-else>
      <div class="appointment-list-2">
        <van-cell-group :border="false">
          <template #title>
            <span class="custom-title">申请提示</span>
          </template>
          <div class="content">
            {{ patient_name }}{{ patient_gender == '女' ? '女士' : '先生' }}您好，申请直系亲属（父母、配偶、子女）代领药品的条件如下，符合其中之一即可：
            <br />
            1、高龄（75周岁以上）
            <br />
            2、脑转移
            <br />
            3、多发性骨转移
            <br />
            4、 影响出行的骨折
            <br />
            *符合其中之一即可，疫情原因特殊报备
            <br />
          </div>
          <van-divider />
          <div class="content">
            申请代领需要的材料如下：
            <br />
            1 、委托代领书（本人、代领人签字）
            <br />
            2、本人、代领人身份证原件、正反面复印件
            <br />
            3、检查报告单原件（近3个月内），须项目医生签字盖章。
            <br />
            *如为检查报告单为复印件，则需加盖医院公章、诊断证明章、病案复印专用章、主治医生处方章（任选其一）
            <br />
            *如申访时已提交，则无需额外提供。
            <br />
            *因高龄申请无需提供此项材料
            <br />
          </div>
        </van-cell-group>
      </div>
      <div style="font-size:12px;color:red;margin:10px 21px;">
        <span style="text-align:left;">请您确认是否符合代领条件并进入下一步申请。如有问题请联系项目办：010-56592455。</span>
      </div>
      <div class="btn-group flex-col">
        <van-button type="default" class="" round @click="$router.push({ name: 'AgentManage' })" color="#0AA8AF">是</van-button>
        <van-button type="default" class="" round @click="showPage2(2)" color="#0AA8AF">否</van-button>
      </div>
    </div>
    <!-- 按钮组 -->
    <div class="btn-group">
      <van-button type="default" class="" plain round @click="back()" color="#0AA8AF">返回</van-button>
    </div>
  </div>
</template>
<script>
import { newPhase, GetReceiveInfo } from '@/api/api'
import { saveSelfReceived, deleteFamily, setFamily } from '@/api/patient'
import { Toast, Divider } from 'vant'
import Vue from 'vue'
import { mapState } from 'vuex'
Vue.use(Toast)
Vue.use(Divider)

export default {
  name: 'agentReceiving',
  data() {
    return {
      title: '领药信息确认',

      patient_name: '',
      patient_gender: '',
      // mode_type:'',
      rounds: '1',
      rounds_phase: '1',
      // receiveInfo:null,
      drugInfo: [],
      drugstore: '',
      drugstore_address: '',
      drugstore_phone: '',
      volunteer_phone: '',
      volunteer_name: '',

      phase_drug_field: { field_1: '' }, //阶段自定义字段:选择最近一次输注时间

      showPage: true, //切换显示页面

      showAgentApply: false //显示代领人按钮
    }
  },
  computed: {
    ...mapState(['patientOne', 'userInfo', 'patientInfo'])
  },
  async created() {
    this.papid = this.patientOne.papid
    await this.getData()
  },
  methods: {
    async getData() {
      // let res = await GetPatient({
      //     papid: this.papid
      // })
      let res = { data: this.patientInfo }
      const { patient, drugstore, phase, predict, volunteer, mode_name, rounds_phase } = res.data
      console.log(res.data)
      this.patient_name = patient.name
      this.patient_gender = patient.gender
      // this.mode_type=mode_name;
      this.rounds = patient.rounds
      this.rounds_phase = rounds_phase
      this.drugstore = drugstore.name
      this.drugstore_address = drugstore.address
      this.drugstore_phone = drugstore.druggist_phone
      this.volunteer_phone = volunteer.mobile
      this.volunteer_name = volunteer.name
      if (predict && predict.show_agent_apply) this.showAgentApply = true
      if (predict && predict.name === '本人') {
        this.$router.replace({ name: 'DrugInfo' })
      }

      let re_info = await GetReceiveInfo({
        papid: this.patientOne.papid
      })
      // this.receiveInfo = re_info.data
      this.drugInfo = re_info.data.drugs
      console.log('receiveInfo', re_info.data)
    },
    // timeFormat(time) {
    //     let year = time.getFullYear();
    //     let month = time.getMonth() + 1;
    //     let day = time.getDate();
    //     return year + '-' + month + '-' + day;
    // },
    back() {
      this.$router.push({ name: 'Timeline' })
    },
    async selfReceived() {
      await saveSelfReceived({ papid: this.papid }).then(res => {
        if (res) {
          //为了刷新setPatientInfo的领药人身份
          if (this.patientInfo.predict) {
            this.patientInfo.predict.name = '本人'
            this.$store.commit("setPatientInfo", this.patientInfo);
          }
          this.$router.replace({ name: 'DrugInfo' })
        }
      })
    },
    showPage2(num) {
      if (num == 1) this.title = '申请提示'
      if (num == 2) this.title = '领药信息确认'
      this.showPage = !this.showPage
    }
  }
}
</script>
<style lang="less" scoped>
.agent-receiving {
  .container {
    min-height: 85vh;

    .appointment-list-2 .van-cell-group__title {
      background: #0aa8af;
      color: white;
    }
    .van-cell-group__title {
      color: #fff;
      padding: 10px;
      .custom-title {
        margin-left: 10px;
      }
      &::after {
        content: '';
        width: 4px;
        height: 15px;
        background-color: #e8f4a6;
        position: absolute;
        left: 25px;
        border-radius: 2px;
      }
    }
    .appointment-list-2 {
      box-sizing: border-box;
      margin: 16px;
      border-radius: 10px;
      box-shadow: 0px 1px 10px 0px rgba(3, 121, 255, 0.1);
      // box-shadow: 0 0 8px rgba(0, 0, 0, 0.15);
      border: 1px solid rgba(255, 255, 255, 0);
      overflow: hidden;
      .content {
        margin: 16px;
        font-size: 14px;
      }
      .van-cell__value {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .alignment-flex {
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
        }
      }
      .appointment-status {
        box-sizing: border-box;
        //   padding: 10px 15px;
        //   margin: 16px;
        border-radius: 10px;
        overflow: hidden;
        //   background-color: #FFDADB;
        font-size: 14px;
        color: #ff4830;
        .img-status {
          display: flex;
          align-items: center;
        }
        &.red {
          color: @red;
        }
      }
    }
    .contain-cell {
      // box-shadow: 0 0 8px  rgba(0, 0, 0, 0.15);
      box-shadow: 0px 1px 10px 0px rgba(3, 121, 255, 0.1);
      border-radius: 8px;
      display: flex;
      flex-flow: column nowrap;
      justify-content: center;
      align-items: center;
      margin: 20px 16px 10px 16px;
      .van-cell {
        border-radius: 8px;
      }
      .timer {
        &::after {
          border-bottom: none !important;
        }
        .van-cell__value {
          flex: 1 0;
        }
        .van-cell__title {
          flex: 2 0;
        }
      }
    }
  }

  .btn-group {
    display: flex;
    // justify-content:space-between;
    // width: 100%;
    padding: 16px;
    button {
      width: 100%;
    }
    // margin: 0;
    //   .van-button{
    //     margin: 0 5px;
    //     white-space: nowrap;
    //   }
  }
  .flex-col {
    display: flex;
    flex-flow: column nowrap;
    button {
      margin-bottom: 10px;
    }
  }

  .btn {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 10px;
    // background-color: white;
    margin: 0;
    .van-button {
      margin: 0 5px;
      white-space: nowrap;
    }
    .btn1 {
      flex-grow: 1;
    }
    .btn2 {
      flex-grow: 4;
    }
  }
}
</style>
